import React, { useEffect, useState } from "react";
import {
    Row, Col, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
//Import Images
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Select from "react-select";
import UnitTypesService from "services/Admin/UnitTypesService";
import PaymentPlanService from "services/Admin/PaymentPlanService";
import SpecialOffersService from "services/Admin/SpecialOffersService";
import CurrencyInput from "react-currency-input-field"

function SpecialOffersModal({ modal, toggle, item}) {
    const [loading, setLoading] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [formData, setFormData] = useState({
        plan: "",
        unit_type: "",
        start_date: "",
        end_date: "",
        amount_requested: "",
        discount: ""
    })
    const [errors, setErrors] = useState({
        plan: false,
        unit_type: false,
        amount_requested: false,
        discount: false
    })
    const [paymentPlanOptions, setPaymentPlanOptions] = useState([])
    const [add, setAdd] = useState(true)
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const unitTypesService = new UnitTypesService()
    const paymentPlanService = new PaymentPlanService()
    const specialOffersService = new SpecialOffersService()
    const amountOptions = [
        {label: "Amount", value: "amount"},
        {label: "Percentage", value: "percentage"},
    ]

    useEffect(() => {
        let params ={
            status: 1
        }
        Promise.all([unitTypesService.getUnitTypesDropDown(item?.id), paymentPlanService.getDropDown(item?.id, params), specialOffersService?.getList({compound_ids: item?.id})]).then(res=>{
            let unitTypes = []
            let paymentPlan = []
            if(res[0]?.status === 200){
                let response = res[0]?.data?.map(info =>{
                    return {
                        ...info,
                        label: info?.name?.en,
                        value: info?.id,
                    }
                })
                setUnitTypeOptions(response)
                unitTypes = response
            }
            if(res[1]?.status === 200){
                let options = []
                res[1]?.data?.map(info =>{
                    info?.years?.map(year=>{
                        options.push({
                            label: `${info?.name?.en} - ${year?.years} year`,
                            value: year?.id
                        })
                    })
                })
                let allInfo = [
                    {label: 'Cash', value: null},
                    ...options
                ]
                paymentPlan = allInfo
                setPaymentPlanOptions(allInfo)
            }
            if(res[2]?.status === 200){
                if(!!res[2]?.data?.data?.length){
                    let response = res[2]?.data?.data[0]
                    setFormData({
                        id: response?.id,
                        plan: response?.payment_year === 'Cash' ? {label: 'Cash', value: null} : paymentPlan?.find(opt=> opt?.value === response?.payment_year?.id) || '',
                        unit_type: response?.unit_type_ids?.map(unitId=> unitTypes?.find(opt=> opt?.value === unitId)) || '',
                        start_date: response?.start_date,
                        end_date: response?.end_date,
                        amount_requested: amountOptions?.find(opt=> opt?.value === response?.amount_requested),
                        discount: response?.discount
                    })
                    setAdd(false)
                } else {
                    setAdd(true)
                }
            }
        })
    }, [])

    const handleValidSubmit = () => {
        if (!formData?.unit_type || !formData?.amount_requested || !formData?.plan || 
            (formData?.amount_requested?.value !== "percentage" && !formData?.discount)) {
            let err ={}
            err['unit_type'] = !formData?.unit_type
            err['amount_requested'] = !formData?.amount_requested
            err['plan'] = !formData?.plan
            err['discount'] = (formData?.amount_requested?.value !== "percentage" && !formData?.discount)

            setErrors(err)
            return
        }
        const data = {
            discount: formData?.discount,
            unit_type_ids: formData?.unit_type?.map(res=> res?.value),
            payment_year_id: formData?.plan?.value,
            end_date: formData?.end_date,
            start_date: formData?.start_date,
            amount_requested: formData?.amount_requested?.value,
            compound_id: item?.id
        }
        setLoading(true)
        if (!add) {
            specialOffersService.update(formData.id, data).then(response => {
                if (response && response.status === SuccessOk) {
                    toast.success(response.data.success)
                    toggle()
                }
                setLoading(false)
            })
        } else {
            specialOffersService.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    toast.success('Special Offers Added Successfully.')
                    toggle()
                }
                setLoading(false)
            })
        }

    }

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
                Special Offers
            </ModalHeader>
            <ModalBody>
                <AvForm className='form-horizontal'
                    onValidSubmit={(e, v) => handleValidSubmit()}>
                        <Row>
                            <Col md={6} className="mb-3">
                                <label className={errors?.plan ? "text-danger" : ""}>Payment Plans</label>
                                <Select
                                    placeholder='Select'
                                    options={paymentPlanOptions}
                                    onChange={e => {
                                        setFormData({...formData, plan: e})
                                        setErrors({...errors, plan: false})
                                    }}
                                    value={formData.plan}
                                />
                                {errors?.plan && <span className="text-danger" style={{fontSize: '10px'}}>This field is required</span>}
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className={errors?.unit_type ? "text-danger" : ""}>Unit Type</label>
                                <Select
                                    placeholder='Select'
                                    options={unitTypeOptions}
                                    onChange={e => {
                                        setFormData({...formData, unit_type: e})
                                        setErrors({...errors, unit_type: false})
                                    }}
                                    value={formData.unit_type}
                                    isMulti
                                />
                                {errors?.unit_type && <span className="text-danger" style={{fontSize: '10px'}}>This field is required</span>}
                            </Col>
                            <Col md={6} className="mb-3">
                                    <AvField
                                        name={"start_date"}
                                        label={"Start Date"}
                                        bsSize="lg"
                                        required
                                        min={new Date().toISOString().split("T")[0]}
                                        errorMessage="This field is required"
                                        value={formData.start_date}
                                        onChange={e=> setFormData({...formData, start_date: e.target.value})}
                                        type={"date"}
                                    />
                            </Col>
                            <Col md={6} className="mb-3">
                                <AvField
                                    name={"end_date"}
                                    label={"End Date"}
                                    bsSize="lg"
                                    required
                                    min={!!formData.start_date ? formData.start_date : new Date().toISOString().split("T")[0]}
                                    errorMessage="This field is required"
                                    value={formData.end_date}
                                    onChange={e => setFormData({...formData, end_date: e.target.value})}
                                    type={"date"}
                                />
                            </Col>
                            <Col md={6}>
                                <label className={errors?.amount_requested ? "text-danger" : ""}>Amount Requested</label>
                                <Select
                                    placeholder='Select'
                                    options={amountOptions}
                                    onChange={(data) => {
                                        setFormData({...formData, amount_requested: data})
                                        setErrors({...errors, amount_requested: false})
                                    }}
                                    value={formData.amount_requested}
                                />
                                {errors?.amount_requested && <span className="text-danger" style={{fontSize: '10px'}}>This field is required</span>}
                            </Col>
                            <Col md={6} className="mb-3 price-input">
                                    <label className={errors?.discount ? "text-danger" : ""}>Discount Value</label>
                                    {formData?.amount_requested?.value === "percentage" ? <AvField
                                        name={"discount"}
                                        bsSize="lg"
                                        required
                                        errorMessage="This field is required"
                                        placeholder={"1.23% e.g"}
                                        value={formData?.discount}
                                        onChange={e => setFormData({...formData, discount: e.target.value})}
                                        type={"number"}
                                        min="0"
                                        max={"100"}
                                    /> :
                                    <CurrencyInput
                                        name={"discount"}
                                        minLength= {1}
                                        value={formData?.discount}
                                        onValueChange={e => {
                                            setFormData({...formData, discount: parseFloat(e)})
                                            setErrors({...errors, discount: false})
                                        }}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                        required
                                        inputProps={{ required: true }}
                                        style={{
                                            height: '42px'
                                        }}
                                        min={"0"}
                                        placeholder={"1 e.g"}
                                    />}
                                    {errors?.discount && <span className="text-danger" style={{fontSize: '10px'}}>This field is required</span>}
                            </Col>
                         </Row>
                    <ModalFooter className="px-0">
                    {add && <button type='submit' disabled={loading} className='btn btn-success w-100'>
                        Submit
                    </button>}
                    {!add && <div className="w-100 d-flex justify-content-between">
                        <button type='button' disabled={loading} onClick={toggle} className='btn btn-secondary'>
                        Cancel
                        </button>
                        <div>
                            <button type='button' disabled={loading} onClick={()=> setDeleteModal(true)} className='btn btn-danger mx-2'>
                            Delete
                            </button>
                            <button type='submit' disabled={loading} className='btn btn-success'>
                            Edit
                            </button>
                        </div>
                    </div>}
                    </ModalFooter>
                </AvForm>
            </ModalBody>
            {deleteModal&& <DeleteModal
                open={deleteModal}
                titleMsg={'Special Offer'}
                deletedItem={formData}
                modelService={specialOffersService}
                onCloseModal={(action) => {
                    setDeleteModal(false)
                    if (action === "delete") {
                        toggle()
                    }
                }}
            />}
        </Modal >
    );
}

export default SpecialOffersModal;
